import { ApplicationRef, inject } from '@angular/core';
import { LanguageService } from '@core/services/language.service';
import { PrefetchingTranslateLoader } from '@core/services/translation-loader.service';

/**
 * An Arabic start loads only ar.json: English would only be the fallback for keys ar.json lacks,
 * and it has every English key (i18n-parity.spec.ts). English is fetched once the first page has
 * settled and the browser is idle, so that switching to it stays instant.
 */
export function prefetchEnglishWhenIdle(): void {
  const language = inject(LanguageService);
  const loader = inject(PrefetchingTranslateLoader);
  if (language.language() === 'en') return;
  void inject(ApplicationRef)
    .whenStable()
    .then(() =>
      whenIdle(() => {
        if (language.language() !== 'en') loader.prefetch('en');
      })
    );
}

function whenIdle(callback: () => void): void {
  if (typeof requestIdleCallback === 'function') requestIdleCallback(() => callback());
  else setTimeout(callback);
}
